import { CustomMetadataSettings } from '../../graphql/schema/types/custom-metadata-settings'

export { OrganizationApplicationsSettingsForm } from './wrapped-form'
export { CustomMetadataFieldInput } from './custom-metadata-field-input'
export { CustomMetadataAgentConfig } from './custom-metadata-agent-config'
export { CustomMetadataForm } from './custom-metadata-form'

export type Importance = 'UNIMPORTANT' | 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL'

export type ReactionOperation = 'NOOP' | 'DISABLE'
export type ParentFieldType = 'STRING' | 'NUMERIC' | 'PERSON_OF_CONTACT'
export type ChildFieldType = 'CONTACT_NAME' | 'PHONE' | 'EMAIL'

export interface BaseCustomMetadataSubfield {
  readonly type: ChildFieldType
  readonly displayLabel: string
  readonly agentLabel: string
  readonly required: boolean
  readonly unique: boolean
}

export interface BaseCustomMetadataField {
  readonly type: ParentFieldType
  readonly displayLabel: string
  readonly agentLabel: string
  readonly required: boolean
  readonly unique: boolean
}

export interface CustomMetadataSubfield extends BaseCustomMetadataSubfield {
  readonly id: string
}

export interface CustomMetadataField extends BaseCustomMetadataField {
  readonly id: string
  readonly subfields?: CustomMetadataSubfield[]
}

export interface CustomMetadataRestrictSettings {
  readonly newAppAction: ReactionOperation
  readonly existingAppAction: ReactionOperation
}

export interface CustomMetadataSubfieldMutation
  extends BaseCustomMetadataSubfield {
  readonly id?: string
}

export interface CustomMetadataFieldMutation extends BaseCustomMetadataField {
  readonly id?: string
  readonly subfields?: CustomMetadataSubfieldMutation[]
}

export interface CustomMetadata extends CustomMetadataSettings {
  readonly fields: CustomMetadataFieldMutation[]
}

export interface RouteCoveragePolicy {
  id: number
  name: string
  coveragePercentage: number
  enabled: boolean
  applicationImportances: Importance[]
  applicationIds: string[]
  allApplications: boolean
}

export interface ApplicationBaseInfo {
  appId: string
  name: string
}

export interface ApiApplicationBaseInfo {
  app_id: string
  name: string
}

export const mapApplicationBaseInfo = ({
  app_id: appId,
  name
}: ApiApplicationBaseInfo) => ({
  appId,
  name
})
